export default "__VITE_ASSET__5b5d2d7c__"